


// import React, { useContext } from "react";
// import { toast, ToastContainer } from "react-toastify";
// import { BsWhatsapp } from "react-icons/bs";
// import { FaTelegramPlane, FaCrown, FaUsers } from "react-icons/fa";
// import { FiCopy, FiCheckCircle } from "react-icons/fi";
// import { GiCoins } from "react-icons/gi";
// import { LanguageContext } from "../Components/LanguageContext";
// import "react-toastify/dist/ReactToastify.css";
// // import "./Refer.css";

// const Refer = ({ user }) => {
//   const { language } = useContext(LanguageContext);

//   if (!user) return null;

//   const copyCode = () => {
//     navigator.clipboard.writeText(user.referral_code);
//     toast.success("Referral Code Copied!", {
//       position: "top-center",
//       autoClose: 1500,
//       hideProgressBar: true,
//       closeOnClick: true,
//       pauseOnHover: false,
//       draggable: true,
//       theme: "dark",
//     });
//   };

//   const copyLink = () => {
//     const link = `https://bajigerludo.com/login/${user.referral_code}`;
//     navigator.clipboard.writeText(link);
//     toast.success("Referral Link Copied!", {
//       position: "bottom-center",
//       autoClose: 1500,
//       hideProgressBar: true,
//       closeOnClick: true,
//       pauseOnHover: false,
//       draggable: true,
//       theme: "dark",
//     });
//   };

//   const shareText = `Hi Friends, Play BAJIGERLUDO Ludo and earn 10000 daily. Download Indian App BAJIGERLUDO
// बम्पर धमाका ऑफर 💸💸💸 💥💥💥💥💥💥
// दोस्तो आ गया है भारत का पहला ऐसा गेमिंग प्लेटफॉर्म जहा आपको win पर रैफर कमीशन 4% दिया जाएगा अगर आपका दोस्त आपके रेफर से गेम खेलता तो आपको 4% commission दिया जायेगा

// BAJIGERLUDO पर लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते हो 
// 100% भरोसेमंद प्लेटफॉर्म । 24 hours support https://bajigerludo.com/login/${user.referral_code}

// Your ReferralCode is -${user.referral_code}.`;

//   return (
//     <div className="refer-wrapper leftContainer mt-5 pt-5">
//       <ToastContainer limit={2} />

//       <div className="refer-container mb-5">
//         {/* Top VIP Badge Banner */}
//         <div className="refer-header">
//           <div className="vip-badge-pill">
//             <FaCrown className="crown-icon" />
//             <span>VIP REFERRAL PROGRAM</span>
//           </div>
//           <h1 className="refer-title">
//             Invite & Earn <span className="highlight-text">Lifetime Cash</span>
//           </h1>
//           <p className="refer-subtitle">
//             Share with friends & get up to{" "}
//             <strong className="commission-text">4% Commission</strong> on every victory!
//           </p>
//         </div>

//         {/* Stats Grid */}
//         <div className="stats-grid">
//           <div className="stat-card network-card">
//             <div className="stat-icon-wrapper blue">
//               <FaUsers />
//             </div>
//             <div className="stat-info">
//               <span className="stat-label">TOTAL NETWORK</span>
//               <h3 className="stat-value">{user.referral_user?.length || 0}</h3>
//             </div>
//           </div>

//           <div className="stat-card earnings-card">
//             <div className="stat-icon-wrapper gold">
//               <GiCoins />
//             </div>
//             <div className="stat-info">
//               <span className="stat-label">TOTAL EARNED</span>
//               <h3 className="stat-value gold">₹{user.referral_earning || 0}</h3>
//             </div>
//           </div>
//         </div>

//         {/* Main Referral Action Box */}
//         <div className="referral-box">
//           <div className="referral-box-header">
//             <span className="box-title">YOUR EXCLUSIVE CODE</span>
//             <span className="perk-tag">Instant Payouts</span>
//           </div>

//           <div className="code-input-group">
//             <div className="code-display">
//               <span className="code-text">{user.referral_code}</span>
//             </div>
//             <button className="copy-code-btn" onClick={copyCode}>
//               <FiCopy className="btn-icon" />
//               <span>COPY CODE</span>
//             </button>
//           </div>

//           {/* How it Works Bar */}
//           <div className="how-it-works-bar">
//             <div className="step-item">
//               <FiCheckCircle className="step-icon" />
//               <span>Share Code</span>
//             </div>
//             <div className="step-divider"></div>
//             <div className="step-item">
//               <FiCheckCircle className="step-icon" />
//               <span>Friends Play</span>
//             </div>
//             <div className="step-divider"></div>
//             <div className="step-item">
//               <FiCheckCircle className="step-icon" />
//               <span>Earn Cash</span>
//             </div>
//           </div>

//           {/* Social Sharing Actions Grid */}
//           <div className="social-actions-section">
//             <p className="social-heading">Share directly via</p>
//             <div className="social-grid">
//               <a
//                 href={`whatsapp://send?text=${encodeURIComponent(shareText)}`}
//                 className="social-btn whatsapp-btn"
//               >
//                 <div className="social-icon-bg">
//                   <BsWhatsapp />
//                 </div>
//                 <span className="social-btn-label">WhatsApp</span>
//               </a>

//               <a
//                 href={`https://t.me/share/url?url=https://bajigerludo.com/login/${user.referral_code}&text=${encodeURIComponent(shareText)}`}
//                 className="social-btn telegram-btn"
//               >
//                 <div className="social-icon-bg">
//                   <FaTelegramPlane />
//                 </div>
//                 <span className="social-btn-label">Telegram</span>
//               </a>

//               <button className="social-btn copylink-btn" onClick={copyLink}>
//                 <div className="social-icon-bg">
//                   <FiCopy />
//                 </div>
//                 <span className="social-btn-label">Copy Link</span>
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Refer;




import React, { useContext } from "react";
import { toast, ToastContainer } from "react-toastify";
import { BsWhatsapp } from "react-icons/bs";
import { FaTelegramPlane, FaCrown, FaUsers } from "react-icons/fa";
import { FiCopy, FiCheckCircle } from "react-icons/fi";
import { GiCoins } from "react-icons/gi";
import { LanguageContext } from "../Components/LanguageContext";
import "react-toastify/dist/ReactToastify.css";
// import "./Refer.css";

const Refer = ({ user }) => {
  const { language } = useContext(LanguageContext);

  if (!user) return null;

  const copyCode = () => {
    navigator.clipboard.writeText(user.referral_code);
    toast.success("Referral Code Copied!", {
      position: "top-center",
      autoClose: 1500,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      theme: "light",
    });
  };

  const copyLink = () => {
    const link = `https://bajigerludo.com/login/${user.referral_code}`;
    navigator.clipboard.writeText(link);
    toast.success("Referral Link Copied!", {
      position: "bottom-center",
      autoClose: 1500,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      theme: "light",
    });
  };

  const shareText = `Hi Friends, Play BAJIGERLUDO Ludo and earn 10000 daily. Download Indian App BAJIGERLUDO
बम्पर धमाका ऑफर 💸💸💸 💥💥💥💥💥💥
दोस्तो आ गया है भारत का पहला ऐसा गेमिंग प्लेटफॉर्म जहा आपको win पर रैफर कमीशन 4% दिया जाएगा अगर आपका दोस्त आपके रेफर से गेम खेलता तो आपको 4% commission दिया जायेगा

BAJIGERLUDO पर लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते हो 
100% भरोसेमंद प्लेटफॉर्म । 24 hours support https://bajigerludo.com/login/${user.referral_code}

Your ReferralCode is -${user.referral_code}.`;

  return (
    <div className="refer-wrapper leftContainer mt-5 pt-5">
      <ToastContainer limit={2} />

      {/* Ambient background blur elements */}
      <div className="refer-ambient-glow glow-1"></div>
      <div className="refer-ambient-glow glow-2"></div>

      <div className="refer-container mb-5">
        {/* Top VIP Badge Banner */}
        <div className="refer-header">
          <div className="vip-badge-pill">
            <FaCrown className="crown-icon" />
            <span>BAMPER DHAMAKA </span>
          </div>
          <h1 className="refer-title">
            Invite & Earn <span className="highlight-text"> Cash</span>
          </h1>
          <p className="refer-subtitle">
            Share with friends & get up to{" "}
            <strong className="commission-text">3% Commission</strong> on every victory!
          </p>
        </div>

        {/* Stats Grid */}
        <div className="stats-grid">
          <div className="stat-card network-card">
            <div className="stat-icon-wrapper blue">
              <FaUsers />
            </div>
            <div className="stat-info">
              <span className="stat-label">TOTAL REFERAL</span>
              <h3 className="stat-value">{user.referral_user?.length || 0}</h3>
            </div>
          </div>

          <div className="stat-card earnings-card">
            <div className="stat-icon-wrapper gold">
              <GiCoins />
            </div>
            <div className="stat-info">
              <span className="stat-label">TOTAL EARNED</span>
              <h3 className="stat-value gold">₹{user.referral_earning || 0}</h3>
            </div>
          </div>
        </div>

        {/* Main Referral Action Box */}
        <div className="referral-box">
          <div className="referral-box-header">
            <span className="box-title">YOUR  CODE</span>
            <span className="perk-tag">Instant Payouts</span>
          </div>

          <div className="code-input-group">
            <div className="code-display">
              <span className="code-text">{user.referral_code}</span>
            </div>
            <button className="copy-code-btn" onClick={copyCode}>
              <FiCopy className="btn-icon" />
              <span>COPY CODE</span>
            </button>
          </div>

       

          {/* Social Sharing Actions Grid */}
          <div className="social-actions-section">
            <p className="social-heading">Share directly via</p>
            <div className="social-grid">
              <a
                href={`whatsapp://send?text=${encodeURIComponent(shareText)}`}
                className="social-btn whatsapp-btn"
              >
                <div className="social-icon-bg">
                  <BsWhatsapp />
                </div>
                <span className="social-btn-label">WhatsApp</span>
              </a>

              <a
                href={`https://t.me/share/url?url=https://bajigerludo.com/login/${user.referral_code}&text=${encodeURIComponent(shareText)}`}
                className="social-btn telegram-btn"
              >
                <div className="social-icon-bg">
                  <FaTelegramPlane />
                </div>
                <span className="social-btn-label">Telegram</span>
              </a>

              <button className="social-btn copylink-btn" onClick={copyLink}>
                <div className="social-icon-bg">
                  <FiCopy />
                </div>
                <span className="social-btn-label">Copy Link</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Refer;